const WALLET_TX_KIND_LABELS: Record<string, string> = Object.assign(Object.create(null), {
  deposit: "Deposit",
  deposit_reversal: "Refund",
  pack_open: "Pack open",
  sellback_credit: "Sellback",
  withdraw_request: "Withdraw request",
  withdraw_payout: "Withdraw payout",
  withdraw_reversal: "Withdraw reversal",
  admin_adjust: "Admin adjust",
  giveaway_credit: "Giveaway",
  affiliate_tier_credit: "Affiliate Max Bucks",
  promo_code_credit: "Max Bucks code",
  psa_transfer_fee: "PSA transfer fee",
  psa_transfer_fee_refund: "PSA transfer fee refund",
  withdraw_fee: "Withdrawal fee",
});

const WALLET_TX_STATUS_LABELS: Record<string, string> = Object.assign(Object.create(null), {
  pending: "Pending",
  completed: "Completed",
  failed: "Failed",
  reversed: "Reversed",
});

const WALLET_DEPOSIT_STATUS_LABELS: Record<string, string> = Object.assign(Object.create(null), {
  pending: "Pending",
  failed: "Failed",
  succeeded: "Succeeded",
  reversed: "Reversed",
  refunded: "Refunded",
  partially_refunded: "Partially refunded",
  disputed: "Disputed",
  partially_disputed: "Partially disputed",
});

function titleCaseSnake(value: string): string {
  const parts = value.split("_").filter((part) => part.length > 0);
  if (parts.length === 0) return value;
  const [first, ...rest] = parts;
  return [
    first.charAt(0).toUpperCase() + first.slice(1).toLowerCase(),
    ...rest.map((part) => part.toLowerCase()),
  ].join(" ");
}

export function labelWalletTxKind(kind: string, sourceType?: string | null): string {
  if (kind === "deposit_reversal" && sourceType === "dispute") {
    return "Dispute";
  }
  return WALLET_TX_KIND_LABELS[kind] ?? titleCaseSnake(kind);
}

export function labelWalletTxStatus(status: string): string {
  return WALLET_TX_STATUS_LABELS[status] ?? titleCaseSnake(status);
}

export function labelWalletDepositStatus(status: string): string {
  return WALLET_DEPOSIT_STATUS_LABELS[status] ?? titleCaseSnake(status);
}

const WALLET_OPEN_WITHDRAWAL_STATUS_LABELS: Record<string, string> = Object.assign(
  Object.create(null),
  {
    pending: "Pending",
    failed: "Failed",
  },
);

export function labelWalletOpenWithdrawalStatus(status: string): string {
  return WALLET_OPEN_WITHDRAWAL_STATUS_LABELS[status] ?? titleCaseSnake(status);
}

export const OPEN_PAYMENTS_SECTION_TITLE = "Open payments";
export const OPEN_PAYMENTS_CONTINUE_CTA = "Continue payment";
export const OPEN_PAYMENTS_RETRY_CTA = "Try again";
export type WalletConnectState = "not_started" | "setup_incomplete" | "payouts_ready";

export function resolveWalletConnectState(input: {
  hasAccount: boolean;
  payoutsEnabled: boolean;
}): WalletConnectState {
  if (input.payoutsEnabled) return "payouts_ready";
  if (input.hasAccount) return "setup_incomplete";
  return "not_started";
}

const WALLET_CONNECT_STATE_LABELS: Record<WalletConnectState, string> = {
  not_started: "Not started",
  setup_incomplete: "Setup incomplete",
  payouts_ready: "Payouts ready",
};

export function labelWalletConnectState(state: WalletConnectState): string {
  return WALLET_CONNECT_STATE_LABELS[state];
}

export const WALLET_CONNECT_SETUP_CTA = "Set up payouts";
export const WALLET_CONNECT_CONTINUE_CTA = "Continue payout setup";
export const WALLET_CONNECT_READY_LABEL = "Payouts ready";

export const WALLET_CONNECT_RETURN_READY = "Payouts are ready.";
export const WALLET_CONNECT_RETURN_INCOMPLETE =
  "Payout setup isn't finished yet — continue when you're ready.";

export const WALLET_FROZEN_LABEL = "Frozen";
export const WALLET_FROZEN_BANNER_BODY =
  "Wallet activity is paused while we review a payment. Add funds and withdraw aren\u2019t available right now.";

export function labelWalletFrozenState(frozen: boolean): string {
  return frozen ? WALLET_FROZEN_LABEL : "";
}